export const JAVA_CODE = `
import com.alibaba.fastjson.JSON;
import com.alibaba.fastjson.JSONObject;
import org.apache.commons.codec.binary.Base64;
import org.apache.http.HttpEntity;
import org.apache.http.client.ClientProtocolException;
import org.apache.http.client.methods.CloseableHttpResponse;
import org.apache.http.client.methods.HttpGet;
import org.apache.http.client.methods.HttpPost;
import org.apache.http.entity.ContentType;
import org.apache.http.entity.StringEntity;
import org.apache.http.impl.client.CloseableHttpClient;
import org.apache.http.impl.client.HttpClients;
import org.apache.http.util.EntityUtils;
import java.io.IOException;
import java.nio.charset.Charset;
import java.nio.charset.StandardCharsets;
import java.security.GeneralSecurityException;
import java.security.MessageDigest;
import java.util.*;
import java.util.stream.Collectors;

public class ApiInvoke {
    private static String loginUrl = "https://fuwu-open.jkxjxw.com/api/v1/api-auth/authentication/api";

    private static CloseableHttpClient client = HttpClients.createDefault();

    public static void main(String[] args) throws Exception{
        //开发者ClientId
        String accessKey = "accessKey";
        //开发者ClientSecret
        String secret = "secret";
        //开发者用户名
        String username = "username";
        //开发者密码
        String password = "password";
        //获取token
        String token = getToken(accessKey, secret, username, password);

        //get请求参数(以获取文档列表为例)
        String url = "https://fuwu-open.jkxjxw.com/api/v1/invoke-v2/documents/all?columnId=1&resourceDegree=&subjectId=26&versionId=&textbookId=&bookNodeId=&documentTypeId=&provinceId=&year=&pageNumber=1&pageSize=10&orderBy=updateTime&direction=desc";
        String[] paramArray = url.split("\\\\?");
        String param = "";
        if(paramArray.length > 1){
            param = paramArray[1];
        }
        Map<String, String> map = new HashMap<>();
        String[] split = param.split("&");
        for(String s : split){
            String[] array = s.split("=");
            if(array.length > 1){
                map.put(array[0], array[1]);
            }
        }
        Map<String, String> getMap = SignUtil.buildParam(map, accessKey, secret, 10);
        //调用接口获取数据并输出
        String data = getData(url, token, getMap);
        System.out.println(data);
    }

    /** 设置头部 **/
    private static String getHeader(String clientId, String clientSecret) {
        String auth = clientId + ":" + clientSecret;
        byte[] encodedAuth = Base64.encodeBase64(auth.getBytes(Charset.forName("US-ASCII")));
        String authHeader = "Basic " + new String(encodedAuth);
        return authHeader;
    }

    /** 获取Token **/
    public static String getToken(String clientId, String clientSecret, String username, String password) throws IOException {
        HttpPost post = new HttpPost(loginUrl);
        JSONObject pushObject = new JSONObject();
        pushObject.put("username",username);
        pushObject.put("password",password);
        /** 构造请求数据 **/
        StringEntity myEntity = new StringEntity(JSON.toJSONString(pushObject), ContentType.APPLICATION_JSON);
        String header = getHeader(clientId, clientSecret);
        post.addHeader("Authorization", header);
        post.addHeader("Content-Type","application/json");
        post.setEntity(myEntity); // 设置请求体
        String responseContent = null;
        CloseableHttpResponse response = null;
        try {
            response = client.execute(post);
            if (response.getStatusLine().getStatusCode() == 200) {
                HttpEntity entity = response.getEntity();
                responseContent = EntityUtils.toString(entity, "UTF-8");
            }

            JSONObject jsonObject = JSON.parseObject(responseContent);
            if(null == jsonObject){
                return "";
            }
            return (String) ((JSONObject)jsonObject.get("data")).get("access_token");
        } catch(ClientProtocolException e) {
            e.printStackTrace();
        } catch(IOException e) {
            e.printStackTrace();
        } finally {
            if (response != null){
                response.close();
            }
        }
        return null;
    }

    /**
     * 获取数据
     * @param url 接口路径
     * @param token 获取的授权
     * @param map 存有所需参数的map
     */
    public static String getData(String url, String token, Map<String, String> map) throws IOException {
        HttpGet get = new HttpGet(url);
        get.addHeader("Authorization","Bearer"+ " " + token);
        get.addHeader("Content-Type","application/json");
        get.addHeader("accesskey",map.get("accesskey"));
        get.addHeader("timestamp",map.get("timestamp"));
        get.addHeader("nonce",map.get("nonce"));
        get.addHeader("sign",map.get("sign"));
        CloseableHttpResponse httpResponse = null;
        String response = "";
        try {
            httpResponse = client.execute(get);
            response = EntityUtils.toString(httpResponse.getEntity());
        } catch (IOException e) {
            e.printStackTrace();
        } finally {
            if(null != httpResponse){
                httpResponse.close();
            }
        }
        return response;
    }
}

class SignUtil {
    public static final int NONCE_MAX_LENGTH = 20;
    public static final String ACCESSKEY = "accesskey";
    public static final String TIMESTAMP = "timestamp";
    public static final String NONCE = "nonce";
    public static final String SIGN = "sign";

    public static String sha1(String str) throws IOException {
        return byte2hex(getShA1Digest(str));
    }

    private static byte[] getShA1Digest(String data) throws IOException {
        byte [] bytes;
        try {
            MessageDigest md = MessageDigest.getInstance("SHA-1");
            bytes = md.digest(data.getBytes(StandardCharsets.UTF_8));
        } catch (GeneralSecurityException gse) {
            throw new IOException(gse);
        }
        return bytes;
    }

    private static String byte2hex( byte [] bytes) {
        StringBuilder sign = new StringBuilder();
        for ( byte aByte : bytes) {
            String hex = Integer. toHexString (aByte & 0xFF );
            if (hex.length() == 1) {
                sign.append("0");
            }
            sign.append(hex.toUpperCase());
        }
        return sign.toString();
    }

    /**
     * 参数签名
     * @param params 待签名的参数
     * @param secret 开发者获取的ClientSecret
     * @return string
     * @throws IOException io异常
     */
    public static String sign(Map<String, String> params, String secret) throws IOException {
        String result = params == null ? null :
                new ArrayList<>(params.keySet()).stream()
                        .sorted()
                        .filter(t -> params .get(t) != null || ! "" .equals( params .get(t)))
                        .map(t -> t + "=" + params .get(t))
                        .collect(Collectors. joining ( "&" )) + "&secretKey=" +secret;
        return sha1 (result);
    }

    /**
     * 生成有限位数的随机数（最长20位）
     * @param length 长度大小
     * @return string
     */
    public static String getRandomNickname(int length) {
        int maxLength = NONCE_MAX_LENGTH ;
        if (length > maxLength) {
            length = maxLength;
        }
        StringBuilder val = new StringBuilder();
        Random random = new Random();
        for ( int i = 0 ; i < length; i++) {
            val.append(random.nextInt( 10 ));
        }
        return val.toString();
    }

    /**
     * 构建请求签名参数
     * @param <T> 参数
     * @param data 参与签名计算的请求参数
     * @param accessKey 平台分配的clientId
     * @param secret 平台分配的clientSecret
     * @param nonceLength 随机数长度，不超过20位
     * @return
     * @throws Exception
     */
    public static <T> Map<String, String> buildParam(T data, String accessKey, String secret, int nonceLength) throws Exception {
        Map<String, String> map = new HashMap<>();
        Map<String, String> paramMap = new HashMap<>();
        String timestamp = String.valueOf(System. currentTimeMillis());
        String nonce = getRandomNickname(nonceLength);
        paramMap.put(ACCESSKEY , accessKey);
        paramMap.put(TIMESTAMP , timestamp);
        paramMap.put(NONCE , nonce);

        if (data.getClass().newInstance() instanceof HashMap) {
            paramMap.putAll((Map<? extends String, ? extends String>) data);
        }
        map.put(SIGN , sign(paramMap, secret));
        map.put(ACCESSKEY , accessKey);
        map.put(TIMESTAMP , timestamp);
        map.put(NONCE , nonce);
        return map;
    }
}
`

export const PHP_CODE = `
<?php

  class ApiCall{
   /**
    * 获取阶段
    */
    // 访问地址
    private static  $LOGIN_URL = "https://fuwu-open.jkxjxw.com/v1/auth/authentication/api";
    private static  $CLIENT_ID = "clientId";
    private static  $CLIENT_SECRET = "clientSecret";
    private static  $USER_NAME = "username";
    private static  $PASSWORD = "password";

	  // 设置头部
    private static function getHeader() {
       $auth = self::$CLIENT_ID.":".self::$CLIENT_SECRET;
	     // base64 加密
       $encodedAuth = base64_encode($auth);
       $authHeader = "Authorization: Basic ".$encodedAuth;
       return $authHeader;
    }

	  // 获取Token
    public  static function getToken(){
          $data = json_encode(array("username"=>self::$USER_NAME , "password"=>self::$PASSWORD));
		      $headers=[
            'Content-type:application/json',
            self::getHeader(),
          ];
          $result=Curl::to(self::$LOGIN_URL)
            ->withHeaders($headers)
            ->withData($data)
            ->post();

		      $ret = json_decode($result, true);
		      return $ret["data"]["access_token"];
    }

	  // 调用数据
    public static function getStage($token){
        $api = "https://fuwu-open.jkxjxw.com/v1/api/stages";
        $headers=[
            "Content-type:application/json",
            "Authorization: Bearer $token",
        ];
        $result=Curl::to($api)
            ->withHeaders($headers)
            ->get();

		return json_decode($result,true);
    }
  }
  ?>
`

export const NET_CODE = `
using System;
using System.Collections.Generic;
using System.Linq;
using System.Text;
using System.Net;
using System.IO;
using System.Web.Script.Serialization;
namespace InvokeApplication
{
	public class AccessToken
	{
		public string access_token { get; set; }
		public string expires_in { get; set; }
		public string refresh_token { get; set; }
	}
	public class Result
	{
		public int code { get; set; }
		public string msg { get; set; }
		public AccessToken accessToken { get; set; }
	}

   class HelloWorld
   {
	   // 登录URL
	  private  static string loginUrl = "https://fuwu-open.jkxjxw.com/v1/auth/authentication/api";
	  private  static string clientId = "clientId";
	  private  static string clientSecret = "clientSecret";
	  private  static string username = "username";
	  private  static string password = "password";
	   // 生成登录所需base64
	   private static string getHeader() {
		   string auth = string.Format("{0}:{1}", clientId, clientSecret);
		   string encode = "";
            byte[] bytes = Encoding.GetEncoding("utf-8").GetBytes(auth);
             encode = Convert.ToBase64string(bytes);
		   string authHeader = "Basic " + encode;
		   return authHeader;
	   }

	   //  获取调用接口的token
	  public static string getToken(){
		  HttpWebRequest request = WebRequest.Create(loginUrl);
			string postData = "username="+username;
				postData += "&password="+password;
			btye[] data = Encoding.ASCII.GetBytes(postData);
			request.Method = "POST";
			request.ContentType = "application/json;charset=utf-8";
			request.ContentLength = data.Length;
			// 登录头部设置
			WebHeaderCollection head = new WebHeaderCollection();
			head.Add("Authorization", getHeader());
			request.Headers = head;
			Stream  stream = request.GetRequestStream();
			stream.Write(data, 0, data.Length);
			stream.close();
			HttpWebResponse response = (HttpWebResponse)request.GetResponse();
			string  responseString = new StreamReader(response.GetResponseStream()).ReadToEnd();
			DataContractJsonSerializer ser = new DataContractJsonSerializer(typeof(Result));
			MemoryStream ms = new MemoryStream(Encoding.UTF8.GetBytes(responseString));
			Result obj = (Result)ser.ReadObject(ms);
			// 返回访问的json
			return obj.accessToken.access_token;
	  }

	   //  获取调用接口的token
	  public static string getToken(){
		  HttpWebRequest request = WebRequest.Create(loginUrl);
			string postData = "username="+username;
				postData += "&password="+password;
			btye[] data = Encoding.ASCII.GetBytes(postData);
			request.Method = "POST";
			request.ContentType = "application/json;charset=utf-8";
			request.ContentLength = data.Length;
			// 登录头部设置
			WebHeaderCollection head = new WebHeaderCollection();
			head.Add("Authorization", getHeader());
			request.Headers = head;
			Stream  stream = request.GetRequestStream();
			stream.Write(data, 0, data.Length);
			stream.close();
			HttpWebResponse response = (HttpWebResponse)request.GetResponse();
			string  responseString = new StreamReader(response.GetResponseStream()).ReadToEnd();
			DataContractJsonSerializer ser = new DataContractJsonSerializer(typeof(Result));
			MemoryStream ms = new MemoryStream(Encoding.UTF8.GetBytes(responseString));
			Result obj = (Result)ser.ReadObject(ms);
			// 返回访问的json
			return obj.accessToken.access_token;
	  }

		  /** 调用数据 **/
		public static void getStage(){
			string getStage = "https://fuwu-open.jkxjxw.com/v1/api/stages";
			HttpWebRequest request = WebRequest.Create(getStage);
				request.Method = "get";
				request.ContentType = "application/json;charset=utf-8";
				// 登录头部设置
				WebHeaderCollection head = new WebHeaderCollection();
				head.Add("Authorization", string.Format("Bearer {0}",getToken());
				request.Headers = head;
				HttpWebResponse response = (HttpWebResponse)request.GetResponse();
				string  responseString = new StreamReader(response.GetResponseStream()).ReadToEnd();

		}

    public  static void Main(string[] args)
      {
	    // 执行调用
         getStage();
      }
   }
}
`
export const PYTHON_CODE = `
# -*- coding:utf-8 -*-
import requests,base64,json

def get_token():
    authentication_addresss = 'https://fuwu-open.jkxjxw.com/v1/auth/authentication/api'
    clientId='clientId'       #需要修改的参数clientId，clientSecret，username（登录名），password（登录密码）
    clientSecret='clientSecret'      #需要修改的参数clientId，clientSecret，username（登录名），password（登录密码）
    Authorization='Basic ' + base64.b64encode(('%s:%s'%(clientId,clientSecret)).encode('utf8')).decode('utf8')
    headers={
        'Authorization':Authorization,
        'Content-Type':'application/json'
    }

    user_data = {
        'username': 'username',    #需要修改的参数clientId，clientSecret，username（登录名），password（登录密码）
        'password': 'password'     #需要修改的参数clientId，clientSecret，username（登录名），password（登录密码）
    }

    auth = requests.get(authentication_addresss, headers=headers, json=user_data)

    return json.loads(auth.text)['data']['access_token']

def get_data_stage(token):
    data_address='https://fuwu-open.jkxjxw.com/v1/api/stages'   #获取数据的接口

    headers={
        'Authorization':'Bearer '+token,
        'Content-Type':'application/json'
    }

    data=requests.get(data_address,headers=headers)

    return json.loads(data.text)['data']

print(get_data_stage(get_token()))
`
export const FORMULAHTML_CODE = `
<!DOCTYPE HTML>
<html>
    <head>
    	<!-- 引入第三方库以显示文档中的公式 -->
    	<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-MML-AM_CHTML"></script>
        <script type="text/x-mathjax-config">
            MathJax.Hub.Config({
              showProcessingMessages: false, //关闭js加载过程信息
              messageStyle: "none", //不显示信息
              extensions: ["tex2jax.js"],
              jax: ["input/TeX", "output/HTML-CSS"],
              tex2jax: {
                inlineMath: [ ['$','$'], ["\\(","\\)"] ], //行内公式选择符
                displayMath: [ ['$$','$$'], ["\\[","\\]"] ], //段内公式选择符
                skipTags: ['script', 'noscript', 'style', 'textarea', 'pre','code','a'], //避开某些标签
                ignoreClass:"comment-content" //避开含该Class的标签
              },
              "HTML-CSS": {
                availableFonts: ["STIX","TeX"], //可选字体
                showMathMenu: false //关闭右击菜单显示
              }
            });
        </script>
	</head>
	<body>
		<div style= 'font-size: 14px; color: #000; line-height: 30px; font-family: MicrosoftYaHei;'>
			<p class="Normal1 a DocDefaults " style="line-height: 150%; vertical-align: middle;"><span class="10 a0 " style="color: #000000; ;font-family: 'SimSun';">（</span><span class="10 a0 " style="color: #000000; ;font-family: 'Times New Roman';">1</span><span class="10 a0 " style="color: #000000;"><span class="" style="font-family: 'SimSun';">）水的深度</span></span><span class="10 a0 " style="color: #000000; font-style: italic;"> <math xmlns="http://www.w3.org/1998/Math/MathML"> <semantics> <mrow> <msub> <mi> h </mi> <mn> 1 </mn> </msub> <mo> = </mo> <mn> 0.05 </mn> <mtext> &#160;m </mtext> </mrow> </semantics> </math></span><span class="10 a0 " style="color: #000000;"><span class="" style="font-family: 'SimSun';">，则水对圆柱体底部的压强：</span></span><span class="a0 "> <math xmlns="http://www.w3.org/1998/Math/MathML"> <semantics> <mrow> <msub> <mi> p </mi> <mn> 1 </mn> </msub> <mo> = </mo> <mi> &#961; </mi> <mi> g </mi> <msub> <mi> h </mi> <mn> 1 </mn> </msub> <mo> = </mo> <mn> 1. </mn> <mtext> 0 </mtext> <mo> &#215; </mo> <msup> <mrow> <mtext> 10 </mtext> </mrow> <mtext> 3 </mtext> </msup> <msup> <mrow> <mtext> &#160;kg/m </mtext> </mrow> <mtext> 3 </mtext> </msup> <mo> &#215; </mo> <mtext> 10&#160;N/kg </mtext> <mo> &#215; </mo> <mtext> 0 </mtext> <mtext> .05&#160;m=500&#160;Pa </mtext> </mrow> </semantics> </math></span><span class="10 a0 " style="color: #000000; ;font-family: 'SimSun';">；</span></p>
		</div>
	<body>
<html>
`

export const MATH_PAPER_CODE = `
// vue调用
<div v-html="content"></div>

// react 调用
<div dangerouslySetInnerHTML={{__html: content}}></div>

// jquery 调用
$(dom).html(content)
`
export const VOD_PAPER_CODE = `
// 具体配置：https://help.aliyun.com/zh/vod/developer-reference/integration?spm=a2c4g.11186623.0.i9#2fa05c02fe0ux

<head>
  <link rel="stylesheet" href="https://g.alicdn.com/de/prismplayer/2.15.2/skins/default/aliplayer-min.css" />  //（可选）如果您的使用场景需要用到H5模式的播放器，则需引用此css文件。
  <script charset="utf-8" type="text/javascript" src="https://g.alicdn.com/de/prismplayer/2.15.2/aliplayer-min.js"></script>  //（必须）引入js文件。
</head>

var player = new Aliplayer(
  {
    id: 'player-con',
    autoplay: false,
    preload: false,
    width: '100%',
    height: '500px',
    source: this.playURL, // 视频播放地址
    cover: this.coverUrl,
    playConfig: {}
  },
  function (player) {}
)
`



// WEBPACK FOOTER //
// ./src/utils/code.js